$(document).ready(function () {
  $('.btn-to-show-list').on('click', function () {
    $('.full-list').toggleClass('hide-list show-list');

    $('.full-list')
      .animate({
        height: "100%",
        width: "100%"
      }, 'fast', 'swing')
      .css({
        transform: "translate(0%, -0)",
        left: "0",
        top: "0",
        zIndex: 100
      });

    $('.btn-to-show-list').toggleClass('d-none');
  });

  $('.close-list').on('click', function () {
    console.log('entrou aqui .close-list');
    $('.btn-to-show-list').toggleClass('d-none');

    $('.full-list')
      .animate({
        width: "220px",
        height: "40px"
      }, 5000, 'linear')
      .css({
        transform: "translate(-50%, -0)",
        left: "50%",
        top: "220px",
        zIndex: "-1"
      });

    $('.full-list').toggleClass('hide-list show-list');

  });

  $('.all-categories').on('click', ' .cat-items-list', function () {
    let _self = $(this);
    let id = _self.data('id');
    let placeToAppend = _self.siblings();

    if (_self.find('.arrow').hasClass('down')) {
      _self.find('.arrow').removeClass('down');
      _self.find('.arrow').css('transform', 'rotate(180deg)');
      getCategories(id, placeToAppend);
    } else {
      placeToAppend.empty();
      _self.find('.arrow').addClass('down');
      _self.find('.arrow').css('transform', 'rotate(0)');
    }
  })

  function getCategories(idCategory, placeToAppend) {
    const xhr = new window.fetchdata();
    const fullUrl = `${baseUrl}/ajaxservice/get-sub-categories/${idCategory}`;
    xhr.fetchData(
      fullUrl,
      'GET',
      undefined,
      (result) => {
        // console.log(result);
        placeToAppend.empty();
        placeToAppend.html(result);
      },
      (result) => {
        console.error(result);
      }
    );
  }

})
